import React from 'react'
import './customer_experience.scss'
import { Container } from 'react-bootstrap';
import VideoPlayer from '../../layout/videoplayer';

const CustomerExperience = () => {
    return (
        <div className='customer_experience'>
            <div className='Thank-you-wrapper'>
                <Container>
                    <div className='top-details'>
                        <h3>401(k) customer experiences</h3>
                        <p>Our customers—and their future—are at the heart of everything we do at Sentry. Watch the video below to hear Heidi Okray, part of the third generation running Spectra Print, share why Sentry is a trusted partner in her company's retirement planning for its employees.</p>
                    </div>
                    <VideoPlayer videoSrc="https://www.w3schools.com/html/mov_bbb.mp4" />
                </Container>
            </div>
        </div>
    )
}

export default CustomerExperience;
